import { ColumnViewModel } from '../../shared/column-types';

export const numVariantsAssociatedToGene_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'hgvsc',
    'hgvsp',
    'coord',
    'alleles',
    'alleleFreqExome',
    'alleleFreqGenome',
    'DBSNPclass',
    'polyphen_score',
    'sift_score',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'variantStrID',
    'diseaseName',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'coord',
  ],
};
